import React from 'react'

const SuccessRequest = () => {
  return (
    
      <div
        className={" bg-gradient-to-b from-[#212445] via-[#212445] to-[#2a2f6c] justify-center items-center flex min-h-screen"}
      >
        <h1 className=" text-white font-bold text-center lg:text-6xl md:text-5xl text-4xl">
          Successfully Requested :)
        </h1>
      </div>
    )
}

export default SuccessRequest